<template>
  <button :class="buttonClass" :disabled="processing">
    <span v-if="processing">
      <loader theme="button" width="32" />
      <span class="pl-1" v-if="processingValue">{{ processingValue }}</span>
    </span>
    <span v-else v-html="value"></span>
  </button>
</template>

<script>
import Loader from '@/components/Shared/Loader';

export default {
  name: 'FormButton',

  components: {
    Loader,
  },

  props: {
    value: {
      type: String,
      required: true,
    },

    processingValue: {
      type: String,
      default: '',
      required: false,
    },

    processing: {
      type: Boolean,
      default: false,
    },

    buttonClass: {
      type: [String, Array],
      default: 'button',
    },
  },
};
</script>
